import { Button, DatePicker, Form, Modal, Space } from "antd";
import moment from "moment";

function ValidityModal({
  open = false,
  onSave = () => {},
  onCancel = () => {},
  data = {},
}) {
  return (
    <Modal
      title={"Update Battery Validity"}
      centered
      width={500}
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      <Form
        layout="vertical"
        onFinish={(values) => {
          onSave(values);
        }}
        initialValues={{
          valid_till: data.valid_till ? moment(data.valid_till) : null,
        }}
      >
        <Form.Item label="Valid till" name={"valid_till"}>
          <DatePicker placeholder="Valid till" style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item>
          <Space style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              {"Save"}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default ValidityModal;
